<template>
  <div class="promotion-ticket-table">
    <div class="table-header">
      <h4>Danh sách vé áp dụng</h4>
    </div>
    <table class="ticket-list-table">
      <thead>
        <tr>
          <th>Vé mua</th>
          <th>Loại vé mua</th>
          <th>{{ discountColumnLabel }}</th>
          <th>
            <button
              type="button"
              class="btn-icon btn-add"
              @click="handleAddRow"
            >
              +
            </button>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(item, index) in localTicketList"
          :key="index"
          :class="{ 'row-duplicate': duplicateRows.has(index) }"
        >
          <td>
            <div v-if="duplicateRows.has(index)" class="duplicate-warning">
              <i class="el-icon-warning" /> Vé mua và loại vé mua bị trùng
            </div>
            <validation-provider
              :rules="isTicketRequired ? 'required' : ''"
              :name="`Vé mua hàng ${index + 1}`"
            >
              <el-select
                :key="`ticket_${index}_${item.ticket}`"
                :value="item.ticket"
                placeholder="Chọn vé (để trống = tất cả)"
                clearable
                @change="(val) => handleFieldChange(index, 'ticket', val)"
              >
                <el-option
                  v-for="typeItem in ticketTypeOptions"
                  :key="typeItem.id"
                  :value="typeItem.id"
                  :label="typeItem.name"
                >
                </el-option>
              </el-select>
            </validation-provider>
          </td>
          <td>
            <el-select
              :key="`customer_type_${index}_${item.customer_type}`"
              :value="item.customer_type"
              placeholder="Chọn loại vé"
              clearable
              @change="(val) => handleFieldChange(index, 'customer_type', val)"
            >
              <el-option
                :value="1"
                label="Người lớn"
              >
              </el-option>
              <el-option
                :value="2"
                label="Trẻ em"
              >
              </el-option>
              <el-option
                :value="null"
                label="Không phân biệt"
              >
              </el-option>
            </el-select>
          </td>
          <td>
            <validation-provider
              :rules="discountValueRules"
              :name="`${discountColumnLabel} hàng ${index + 1}`"
            >
              <input
                v-model="item.discount_value"
                v-numeric-only
                type="text"
                :placeholder="isPercentDiscount ? '%' : 'Tiền'"
                @input="(e) => handleFieldChange(index, 'discount_value', e.target.value)"
              />
            </validation-provider>
          </td>
          <td>
            <button
              type="button"
              class="btn-icon btn-remove"
              :disabled="localTicketList.length <= 1"
              @click="handleRemoveRow(index)"
            >
              -
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { VOUCHER_TYPE_VALUE } from './constant'

export default {
  name: 'PromotionApplyTicketListTable',
  props: {
    ticketList: {
      type: Array,
      required: true,
      default: () => []
    },
    ticketTypeOptions: {
      type: Array,
      required: true,
      default: () => []
    },
    discountType: {
      type: Number,
      default: VOUCHER_TYPE_VALUE.PERCENT
    }
  },
  data() {
    return {
      localTicketList: []
    }
  },
  computed: {
    isPercentDiscount() {
      return this.discountType === VOUCHER_TYPE_VALUE.PERCENT || this.discountType == null
    },
    discountColumnLabel() {
      return this.isPercentDiscount ? '% giảm giá' : 'Tiền giảm giá'
    },
    isTicketRequired() {
      return this.localTicketList.length > 1
    },
    discountValueRules() {
      if (this.isPercentDiscount) {
        return 'required|min_value:1|max_value:100|integer'
      }
      return 'required|min_value:1|integer'
    },
    duplicateRows() {
      const seen = {}
      const duplicates = new Set()
      this.localTicketList.forEach((item, index) => {
        const key = `${item.ticket ?? '__null__'}_${item.customer_type ?? '__null__'}`
        if (seen[key] !== undefined) {
          duplicates.add(seen[key])
          duplicates.add(index)
        } else {
          seen[key] = index
        }
      })
      return duplicates
    }
  },
  watch: {
    ticketList: {
      immediate: true,
      deep: true,
      handler(newVal) {
        this.localTicketList = JSON.parse(JSON.stringify(newVal || []))
      }
    }
  },
  methods: {
    handleFieldChange(index, field, value) {
      if (this.localTicketList[index]) {
        this.$set(this.localTicketList[index], field, value)
        this.$emit('update-field', {
          index,
          field,
          value,
          updatedList: JSON.parse(JSON.stringify(this.localTicketList))
        })
      }
    },
    handleAddRow() {
      const newRow = {
        ticket: null,
        customer_type: null,
        discount_value: null
      }
      this.localTicketList.unshift(newRow)
      this.$emit('add-row', {
        updatedList: JSON.parse(JSON.stringify(this.localTicketList))
      })
    },
    handleRemoveRow(index) {
      if (this.localTicketList.length > 1) {
        this.localTicketList.splice(index, 1)
        this.$emit('remove-row', {
          index,
          updatedList: JSON.parse(JSON.stringify(this.localTicketList))
        })
      }
    }
  }
}
</script>

<style scoped>
.promotion-ticket-table {
  width: 100%;
  margin-top: 1rem;
  max-height: 400px;
  overflow-y: auto;
  overflow-x: auto;
}

.promotion-ticket-table::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.promotion-ticket-table::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.promotion-ticket-table::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

.promotion-ticket-table::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.table-header {
  margin-bottom: 0.5rem;
}

.table-header h4 {
  margin: 0;
  font-weight: 600;
  font-size: 16px;
  color: #303133;
}

.ticket-list-table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #e0e0e0;
}

.ticket-list-table thead {
  background-color: #e8f5e9;
  position: sticky;
  top: 0;
  z-index: 10;
}

.ticket-list-table thead th {
  padding: 8px;
  text-align: left;
  border: 1px solid #e0e0e0;
  font-weight: 600;
  font-size: 14px;
  color: #000;
}

.ticket-list-table thead th:nth-child(1) {
  width: 40%;
}

.ticket-list-table thead th:nth-child(2) {
  width: 30%;
}

.ticket-list-table thead th:nth-child(3) {
  width: 20%;
}

.ticket-list-table thead th:nth-child(4) {
  width: 10%;
  text-align: center;
}

.ticket-list-table tbody tr {
  border-bottom: 1px solid #e0e0e0;
  transition: background-color 0.2s;
}

.ticket-list-table tbody tr:hover {
  background-color: #fafafa;
}

.ticket-list-table tbody td {
  padding: 8px;
  border: 1px solid #e0e0e0;
  vertical-align: middle;
}

.ticket-list-table tbody td:nth-child(1) {
  min-width: 180px;
}

.ticket-list-table tbody td:nth-child(3) {
  width: 120px;
  min-width: 120px;
  max-width: 160px;
}

.ticket-list-table tbody td:nth-child(4) {
  width: 50px;
  min-width: 50px;
  max-width: 50px;
  text-align: center;
}

.ticket-list-table tbody td input,
.ticket-list-table tbody td .el-select {
  width: 100%;
}

.ticket-list-table tbody td input {
  padding: 8px 12px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  font-size: 14px;
  transition: border-color 0.2s;
}

.ticket-list-table tbody td input:focus {
  outline: none;
  border-color: #409eff;
}

.ticket-list-table tbody td .el-select {
  font-size: 14px;
}

.btn-icon {
  padding: 4px 8px;
  margin: 0 2px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background-color: #fff;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  transition: all 0.2s;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 32px;
  height: 32px;
}

.btn-icon:hover:not(:disabled) {
  background-color: #ecf5ff;
  border-color: #b3d8ff;
}

.btn-icon:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn-icon.btn-add {
  color: #67c23a;
  border-color: #67c23a;
}

.btn-icon.btn-add:hover:not(:disabled) {
  background-color: #f0f9ff;
  border-color: #67c23a;
}

.btn-icon.btn-remove {
  color: #f56c6c;
  border-color: #f56c6c;
}

.btn-icon.btn-remove:hover:not(:disabled) {
  background-color: #fef0f0;
  border-color: #f56c6c;
}

.row-duplicate {
  background-color: #fff8e1 !important;
}

.duplicate-warning {
  color: #e6a23c;
  font-size: 12px;
  margin-bottom: 4px;
  display: flex;
  align-items: center;
  gap: 4px;
}
</style>
